/**
 * Styles that hide text from the eye and leave it to a screen reader — for
 * words the layout already says visually, by an outline, a colour or a
 * position, that assistive technology would otherwise miss.
 *
 * A style object rather than a class, so a `makeStyles` block can take it as a
 * rule or inside a breakpoint.
 */
export const visuallyHidden = {
  position: 'absolute',
  width: 1,
  height: 1,
  margin: -1,
  padding: 0,
  border: 0,
  overflow: 'hidden',
  clip: 'rect(0 0 0 0)',
  whiteSpace: 'nowrap',
} as const;
